import { CommonIconProps } from "./types";

export const CloudArrowDown = ({ width = 32, height = 23, color = "#3100F7" }: CommonIconProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 32 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M25.9691 8.03164C24.7959 3.63048 20.7046 0.5 16 0.5C11.2954 0.5 7.20412 3.63054 6.03088 8.03164C2.54931 8.73173 0 11.6926 0 15.1667C0 19.2103 3.3925 22.5 7.5625 22.5H15.0625H16H16.9375H24.4375C28.6075 22.5 32 19.2103 32 15.1667C32 11.6926 29.4507 8.73173 25.9691 8.03164Z"
        fill={color}
      />
      <path
        d="M15.3372 16.8226C15.5202 17.0017 15.7601 17.0911 16 17.0911C16.24 17.0911 16.4799 17.0017 16.6629 16.8226L18.5379 14.9893C18.904 14.6313 18.904 14.0509 18.5379 13.6929C18.1718 13.335 17.5782 13.335 17.2121 13.6929L16.9375 13.9615V10.6745C16.9375 10.1682 16.5178 9.75781 16 9.75781C15.4823 9.75781 15.0625 10.1682 15.0625 10.6745V13.9615L14.7879 13.6929C14.4218 13.335 13.8282 13.335 13.4621 13.6929C13.096 14.0509 13.096 14.6313 13.4621 14.9893L15.3372 16.8226Z"
        fill="white"
      />
    </svg>
  );
};
